module.exports = __webpack_public_path__ + "img/float-mini.caa7fd5d.gif";